/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus-circle-icon': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data:
      '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8 1.778a6.222 6.222 0 100 12.444A6.222 6.222 0 008 1.778zM0 8a8 8 0 1116 0A8 8 0 010 8zm8-3.733c.49 0 .889.398.889.889V7.11h1.955a.889.889 0 110 1.778H8.89v1.955a.889.889 0 11-1.778 0V8.89H5.156a.889.889 0 010-1.778H7.11V5.156c0-.491.398-.89.889-.89z" _fill="#8C4DDF"/>'
  }
})
